import { render } from "./select-games.vue?vue&type=template&id=2e24094b&scoped=true"
import script from "./select-games.vue?vue&type=script&lang=js"
export * from "./select-games.vue?vue&type=script&lang=js"

import "./select-games.vue?vue&type=style&index=0&id=2e24094b&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e24094b"]])

export default __exports__